module.exports = "<div class=\"modal-header\">\n    <h3 class=\"modal-title\" id=\"modal-title\">大图</h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n    <p>\n        <img width=\"320\" height=\"320\" src=\"{{maxImage}}\" />\n    </p>\n</div>\n<div class=\"modal-footer\">\n    <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel(1)\">关闭</button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/user/modal/maximage.html
// module id = 160
// module chunks = 0